import React from 'react';
import { Link } from 'react-router-dom';
import './GetInvolved.css';

const GetInvolved = () => {
  return (
    <div className="get-involved-page">
      <section className="page-hero">
        <div className="page-hero-overlay"></div>
        <div className="page-hero-content">
          <h1>Get Involved</h1>
          <p>Join us in creating lasting positive change</p>
        </div>
      </section>

      <section className="intro-section">
        <div className="container">
          <div className="intro-content">
            <h2>Be Part of the Change</h2>
            <div className="section-line"></div>
            <p className="lead">
              Real change happens when people come together with a shared purpose. You can support our mission
              by partnering with us, volunteering, or contributing to our initiatives. Together, we can create
              safer childhoods, stronger communities, and a more sustainable future.
            </p>
          </div>
        </div>
      </section>

      <section className="involvement-options">
        <div className="container">
          <div className="options-grid">
            <div className="option-card">
              <div className="option-icon">
                <img src="https://images.unsplash.com/photo-1582213782179-e0d53f98f2ca?w=400" alt="Partnership" />
              </div>
              <h3>Working Together (Partnerships)</h3>
              <p>
                Partner with us to create meaningful impact in communities. We collaborate with government agencies,
                corporates, NGOs, and educational institutions to design and implement programs that address critical
                social challenges.
              </p>
              <ul>
                <li>Corporate Social Responsibility (CSR) partnerships</li>
                <li>Government program collaborations</li>
                <li>Institutional partnerships</li>
                <li>NGO collaborations</li>
              </ul>
              <Link to="/contact" className="btn btn-primary">Partner With Us</Link>
            </div>

            <div className="option-card">
              <div className="option-icon">
                <img src="https://images.unsplash.com/photo-1559027615-cd4628902d4a?w=400" alt="Volunteering" />
              </div>
              <h3>Volunteering</h3>
              <p>
                Contribute your time, skills, and passion to support our programs. Whether you're a professional,
                student, or community member, there are many ways to volunteer and make a difference.
              </p>
              <ul>
                <li>Program facilitation and training</li>
                <li>Community outreach activities</li>
                <li>Event support and coordination</li>
                <li>Skill-based volunteering (research, communication, etc.)</li>
              </ul>
              <Link to="/contact" className="btn btn-primary">Become a Volunteer</Link>
            </div>

            <div className="option-card">
              <div className="option-icon">
                <img src="https://images.unsplash.com/photo-1522071820081-009f0129c71c?w=400" alt="Internship" />
              </div>
              <h3>Internship</h3>
              <p>
                Gain hands-on experience in the development sector while contributing to meaningful social change.
                Our internship programs offer opportunities to learn, grow, and develop professional skills across
                various domains.
              </p>
              <ul>
                <li>Social work and community development</li>
                <li>Program management and research</li>
                <li>Communication and campaign design</li>
                <li>Monitoring and evaluation</li>
              </ul>
              <Link to="/contact" className="btn btn-primary">Apply for Internship</Link>
            </div>
          </div>
        </div>
      </section>

      <section className="why-join">
        <div className="container">
          <h2>Why Join Us?</h2>
          <div className="section-line"></div>

          <div className="why-grid">
            <div className="why-item">
              <div className="why-number">01</div>
              <h3>Create Real Impact</h3>
              <p>Work directly with communities and see tangible results from your efforts</p>
            </div>

            <div className="why-item">
              <div className="why-number">02</div>
              <h3>Professional Growth</h3>
              <p>Develop skills and gain experience in the social development sector</p>
            </div>

            <div className="why-item">
              <div className="why-number">03</div>
              <h3>Collaborative Environment</h3>
              <p>Work with experienced professionals passionate about social change</p>
            </div>

            <div className="why-item">
              <div className="why-number">04</div>
              <h3>Meaningful Work</h3>
              <p>Contribute to building safer childhoods and stronger communities</p>
            </div>
          </div>
        </div>
      </section>

      <section className="cta-section">
        <div className="container">
          <div className="cta-content">
            <h2>Ready to Make a Difference?</h2>
            <p>Get in touch with us today and let's work together to create positive change.</p>
            <Link to="/contact" className="btn btn-large">Contact Us</Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default GetInvolved;
